<script>
import {mapState} from "vuex";
import Loading from "@/components/Loading";
import PageHeader from "@/components/page-header";
import {updatePayment, createPayment, getPayment} from "@/api/payment";
import {getShortSites} from "@/api/sites";

export default {
  components: {PageHeader, Loading},
  data() {
    return {
      loading: false,
      title: this.$route.params.paymentId ? "Ödeme Düzenle" : "Ödeme Ekle",
      sites: [],
      items: [
        {
          text: "Kasa Yönetimi",
          href: "/payments"
        },
        {
          text: this.$route.params.siteId ? "Ödeme Düzenle" : "Ödeme Ekle",
          active: true
        }
      ],
      amount: null,
      sendedAmount: null,
      commissionTotal: null,
      form: {
        _site: null,
        baseAmount: null,
        exchangeRate: null,
        exchangeTotal: null,
        commission: null,
        commissionType: "included",
        commissionTotal: null,
        sendedAmount: null,
        txId: null,
        targetWallet: null,
        description: null,
        amount: null,
      }
    };
  },
  computed: {
    ...mapState({
      config: state => state.auth.config,
    }),
  },
  methods: {
    submitForm() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.loading = true;
          if (this.$route.params.paymentId) {

            const sendData = {
              ...this.form
            };
            sendData.commissionTotal = this.commissionTotal;
            sendData.amount = this.amount;
            sendData.sendedAmount = this.sendedAmount;

            updatePayment(this.$route.params.paymentId, sendData).then(() => {
              this.$router.push('/payments');
            }).finally(() => {
              this.loading = false;
            })
          } else {
            const sendData = {
              ...this.form
            };
            sendData.commissionTotal = this.commissionTotal;
            sendData.amount = this.amount;
            sendData.sendedAmount = this.sendedAmount;
            createPayment(sendData).then(() => {
              this.$router.push('/payments');
            }).finally(() => {
              this.loading = false;
            })
          }
        }
      });
    },
    calculateAmount() {
      const rate = (this.form.commission && this.form.commission !== "") ? parseFloat(this.form.commission) : 0;
      this.form.commissionTotal = 0;
      this.commissionTotal = parseFloat(this.form.baseAmount) * parseFloat(rate) / 100;
      if (this.form.commissionType === 'included') {
        this.amount = parseFloat(this.form.baseAmount);
        this.sendedAmount = parseFloat(this.form.baseAmount) - this.commissionTotal;
      } else {
        this.amount = parseFloat(this.form.baseAmount) + parseFloat(this.commissionTotal);
        this.sendedAmount = parseFloat(this.form.baseAmount);
      }
    }
  },
  mounted() {
    getShortSites({page: 1, limit: 1000}).then((response) => {
      this.sites = response.data.data.docs;
      if (this.$route.params.paymentId) {
        getPayment(this.$route.params.paymentId).then((response) => {
          this.form = response.data.data;
          this.commissionTotal = this.form.commissionTotal;
          this.sendedAmount = this.form.sendedAmount;
          this.amount = this.form.amount;
          this.loading = false;
        })
      } else {
        this.loading = false;
      }
    });
  },
  watch: {
    form: {
      deep: true,
      handler() {
        this.calculateAmount();
      }
    }
  },

};

</script>
<template>
  <div>
    <PageHeader :title="title" :items="items"/>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <Loading v-if="loading"/>
          <div class="card-body">
            <form @submit.prevent="submitForm">
              <div class="row">
                <div class="col-4">
                  <div class="form-group mb-2">
                    <label for="site" class="col-form-label">Site</label>
                    <select v-validate="'required'" id="site" name="site" class="form-control custom-select" v-model="form._site">
                      <option v-for="site in sites" :key="site._id" :value="site._id">{{site.name}}</option>
                    </select>
                    <template v-if="errors.firstByRule('site', 'required')">
                      <code class="help is-danger">Bu alan zorunludur.</code>
                    </template>
                  </div>
                </div>
                <div class="col-4">
                  <div class="form-group mb-2">
                    <label for="commissionType" class="col-form-label">Komisyon Tipi</label>
                    <select v-validate="'required'" id="commissionType" name="commissionType" class="form-control custom-select" v-model="form.commissionType">
                      <option value="included">Dahil</option>
                      <option value="excluded">Hariç</option>
                    </select>
                    <template v-if="errors.firstByRule('commissionType', 'required')">
                      <code class="help is-danger">Bu alan zorunludur.</code>
                    </template>
                  </div>
                </div>
                <div class="col-4">
                  <div class="form-group mb-2">
                    <label for="commission" class="col-form-label">Komisyon</label>
                    <input v-validate="'required'" id="commission" name="commission" v-model="form.commission" type="text"
                           class="form-control"/>
                    <template v-if="errors.firstByRule('commission', 'required')">
                      <code class="help is-danger">Bu alan zorunludur.</code>
                    </template>
                  </div>
                </div>


                <div class="col-4">
                  <div class="form-group mb-2">
                    <label for="exchangeRate" class="col-form-label">Güncel Coin Kur</label>
                    <input v-validate="'required'" id="exchangeRate" name="exchangeRate" v-model="form.exchangeRate" type="text"
                           class="form-control"/>
                    <template v-if="errors.firstByRule('exchangeRate', 'required')">
                      <code class="help is-danger">Bu alan zorunludur.</code>
                    </template>
                  </div>
                </div>

                <div class="col-4">
                  <div class="form-group mb-2">
                    <label for="exchangeTotal" class="col-form-label">Gönderilen Coin</label>
                    <input v-validate="'required'" id="exchangeTotal" name="exchangeRate" v-model="form.exchangeTotal" type="text"
                           class="form-control"/>
                    <template v-if="errors.firstByRule('exchangeTotal', 'required')">
                      <code class="help is-danger">Bu alan zorunludur.</code>
                    </template>
                  </div>
                </div>

                <div class="col-4">
                  <div class="form-group mb-2">
                    <label for="baseAmount" class="col-form-label">Tutar</label>
                    <input v-validate="'required'" id="baseAmount" name="baseAmount" v-model="form.baseAmount" type="text" class="form-control"/>
                    <template v-if="errors.firstByRule('baseAmount', 'required')">
                      <code class="help is-danger">Bu alan zorunludur.</code>
                    </template>
                  </div>
                </div>
               <div class="col-12">
                 <hr>
                 <div class="row">
                   <div class="col-4">
                     <div class="form-group mb-2">
                       <label for="baseAmount" class="col-form-label">Kasaya işlenecek Tutar</label>
                       <input readonly v-model="amount" type="text" class="form-control"/>
                     </div>
                   </div>

                   <div class="col-4">
                     <div class="form-group mb-2">
                       <label for="baseAmount" class="col-form-label">Gönderilen Tutar</label>
                       <input readonly v-model="sendedAmount" type="text" class="form-control"/>
                     </div>
                   </div>

                   <div class="col-4">
                     <div class="form-group mb-2">
                       <label for="baseAmount" class="col-form-label">Coin Komisyonu</label>
                       <input readonly v-model="commissionTotal" type="text" class="form-control"/>
                     </div>
                   </div>
                 </div>
                 <hr>
               </div>

                <div class="col-6">
                  <div class="form-group mb-2">
                    <label for="targetWallet" class="col-form-label">Cüzdan</label>
                    <input v-validate="'required'" id="targetWallet" name="targetWallet" v-model="form.targetWallet" type="text"
                           class="form-control"/>
                    <template v-if="errors.firstByRule('targetWallet', 'required')">
                      <code class="help is-danger">Bu alan zorunludur.</code>
                    </template>
                  </div>
                </div>

                <div class="col-6">
                  <div class="form-group mb-2">
                    <label for="txId" class="col-form-label">Tx Id</label>
                    <input v-validate="'required'" id="txId" name="amount" v-model="form.txId" type="text"
                           class="form-control"/>
                    <template v-if="errors.firstByRule('txId', 'required')">
                      <code class="help is-danger">Bu alan zorunludur.</code>
                    </template>
                  </div>
                </div>

                <div class="col-12">
                  <div class="form-group mb-4">
                    <label for="description" class="col-form-label">Açıklama</label>
                    <textarea id="description" name="description" v-model="form.description" type="text" class="form-control"></textarea>
                  </div>
                </div>

              </div>
              <div class="d-flex justify-content-end">
                <button type="submit" class="btn btn-primary">{{$route.params.paymentId ? 'Ödeme Düzenle' : 'Ödeme Ekle'}}</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
